export const maskIfNumber = (num) => {
    if (!num || !num.match(phoneNumberRegex))
        return num;
    return "\u200E" + num.substring(0, 2) + 'X'.repeat(num.length - 2) + "\u200E";
};
const isNumberArabic = (num) => {
    var arabic = /[\u0600-\u06FF]/;
    return arabic.test(num);
};
export const phoneNumberRegex = /(?:\+?[0-9\u0660-\u0669\u06F0-\u06F9-]{9,14})/g;
